import React from 'react'

function ResiListings() {
  return (
    <div>ResiListings</div>
  )
}

export default ResiListings